<template>
  <v-card flat>
    <v-row no-gutters>
      <v-col cols="12">
        <v-btn
          color="primary"
          icon
          @click="handleBack"
          :disabled="
            loadingSkipButton ||
            loadingDeletePauseThumb ||
            loadingPauseThumbnail
          "
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="text-h6 mr-2" style="vertical-align: middle">
          Thumbnails
        </span>
      </v-col>
      <v-col cols="12" class="mt-6 px-1">
        <v-card width="100%" height="38px" flat style="border: 1px solid grey">
          <v-row no-gutters>
            <v-col cols="4">
              <v-btn
                class="px-0"
                block
                :plain="editingThumbnail.type != 'start'"
                tile
                style="border-right: 1px solid grey"
                :color="editingThumbnail.type === 'start' ? 'primary' : ''"
                @click="handleChangeThumbType('start')"
              >
                <span>{{ $t('message.pages.pauseThumbnail.start') }}</span>
              </v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn
                class="px-0"
                block
                :plain="editingThumbnail.type != 'pause'"
                tile
                style="border-right: 1px solid grey"
                :color="editingThumbnail.type === 'pause' ? 'primary' : ''"
                @click="handleChangeThumbType('pause')"
              >
                <span>Pause</span>
              </v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn
                class="px-0"
                block
                :plain="editingThumbnail.type != 'end'"
                tile
                :color="editingThumbnail.type === 'end' ? 'primary' : ''"
                @click="handleChangeThumbType('end')"
              >
                <span>{{ $t('message.pages.pauseThumbnail.end') }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" class="mt-3 mb-0 pb-5">
        <v-row
          no-gutters
          class="pb-2 px-2"
          v-if="editingThumbnail.type == 'start'"
        >
          <span class="mt-1" style="font-weight: 500; font-size: 18px">
            {{ $t('message.pages.video.videoThumbnail') }}
          </span>
          <v-col cols="12">
            <v-card flat class="mt-1 mb-6">
              <span>
                {{ $t('message.pages.videoEditModal.thumbnailText') }}
                <a href="https://tinypng.com/" target="_blank">
                  <u>TinyPNG</u>
                </a>
                {{ $t('message.pages.videoEditModal.thumbnailText2') }}</span
              >
            </v-card>
          </v-col>

          <v-col cols="12" class="d-md-inline-flex">
            <v-card
              v-if="hasEditVideoPerm"
              class="d-flex flex-column justify-center align-center mr-3 card-thumbnail"
              height="83px"
              width="150px"
            >
              <v-file-input
                v-model="newThumbnail.file"
                v-if="!loading"
                height="20px"
                class="d-flex align-center justify-center ma-0 pa-0 pl-2"
                hide-input
                prepend-icon="mdi-cloud-upload-outline"
                accept="image/png, image/jpeg, image/gif"
                @change="handleChangeThumbnail"
              ></v-file-input>
              <span
                v-if="!loading"
                style="
                  font-size: 12px;
                  text-align: center;
                  position: absolute;
                  top: 43px;
                "
              >
                {{ $t('message.pages.video.thumbUpload') }}
              </span>
              <v-progress-circular
                v-else
                :size="22"
                width="3"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-card>

            <v-hover v-slot="{ hover }">
              <v-card
                class="mr-4 d-flex align-center justify-center card-current-thumb"
                height="83px"
                width="150px"
                :class="{
                  'on-hover': hover && !isBunnyThumbnail && defaultThumbnail,
                }"
              >
                <template v-if="defaultThumbnail && !loadingDeleteThumb">
                  <div class="position-relative">
                    <v-card
                      class="default-thumbnail text-light"
                      color="var(--v-primary-base)"
                      :variant="variant"
                      max-width="100%"
                      flat
                    >
                      <v-card-item>
                        <div>
                          <span class="text-center" style="color: aliceblue">{{
                            $t('message.pages.video.defaultThumbnail')
                          }}</span>
                        </div>
                      </v-card-item>
                    </v-card>
                    <div
                      class="thumb-preview"
                      :style="`background: url(${defaultThumbnail});`"
                    ></div>
                  </div>
                </template>
                <template v-else-if="!loadingDeleteThumb">
                  <v-img
                    max-width="50"
                    max-height="50"
                    src="@/assets/pandaHappy.svg"
                  ></v-img>
                </template>

                <div
                  class="align-self-center"
                  v-if="
                    !isBunnyThumbnail &&
                    !loadingDeleteThumb &&
                    defaultThumbnail &&
                    hasEditVideoPerm
                  "
                >
                  <v-btn
                    filter
                    icon
                    class="btn-handle-delete"
                    :class="{ 'show-btn-handle-delete': hover }"
                    @click="handleDeleteThumbnail"
                  >
                    <v-icon> mdi-close </v-icon>
                  </v-btn>
                </div>
                <v-progress-circular
                  v-if="loadingDeleteThumb"
                  :size="22"
                  width="3"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="12 mt-4">
            <span>{{ $t('message.pages.videoEditModal.thumbnailText3') }}</span>
          </v-col>
        </v-row>
        <v-row
          v-if="editingThumbnail.type == 'pause'"
          class="px-1 mt-2"
          no-gutters
        >
          <v-row no-gutters v-if="!isEditingThumb">
            <v-col cols="12">
              <v-row no-gutters>
                <span class="mt-1" style="font-weight: 500; font-size: 18px">
                  {{ $t('message.pages.pauseThumbnail.pauseThumbnailTitle') }}
                  <learn-more-btn :onClickBtn="handleOpenThumbLink" />
                </span>
                <v-spacer />
                <v-btn
                  v-if="!isEditingThumb && hasEditVideoPerm"
                  class="mr-4"
                  color="primary"
                  @click="handleEditThumb"
                >
                  {{ $t('message.add') }}
                </v-btn>
              </v-row>
            </v-col>
            <v-col cols="12" class="mt-2">
              <v-card
                v-scroll.self="onScroll"
                class="overflow-y-auto"
                flat
                max-height="100%"
                width="100%"
              >
                <v-row no-gutters v-if="pauseThumbnails.length">
                  <v-col
                    cols="12"
                    v-for="(pauseThumb, i) in pauseThumbnails"
                    :key="i"
                  >
                    <v-card class="mt-2 pl-2 mr-6" outlined height="45px">
                      <v-row class="fill-height" no-gutters align="center">
                        <span>{{ pauseThumb.metadata.thumb.title }}</span>
                        <v-spacer />
                        <v-progress-circular
                          v-if="
                            loadingDeletePauseThumb &&
                            beingDeletePauseThumbId === pauseThumb.id
                          "
                          class="mr-2"
                          indeterminate
                          color="primary"
                          size="22"
                          width="3"
                        ></v-progress-circular>
                        <v-menu bottom left offset-y v-if="hasEditVideoPerm">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mr-2" icon v-bind="attrs" v-on="on">
                              <v-icon>mdi-dots-horizontal</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense class="pa-0" width="120px">
                            <v-list-item @click="handleEditThumb(pauseThumb)">
                              <v-list-item-title>{{
                                $t('message.pages.videoPlayerButtons.edit')
                              }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="handleRemoveThumb(pauseThumb)">
                              <v-list-item-title class="error--text">{{
                                $t('message.pages.videoEditModal.delete')
                              }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row no-gutters v-else>
                  <v-card
                    height="100px"
                    width="100%"
                    class="d-flex flex-row align-center justify-center"
                  >
                    <span>{{
                      $t('message.pages.pauseThumbnail.noPauseThumbnailListed')
                    }}</span>
                  </v-card>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-col cols="12" v-if="isEditingThumb">
            <v-row no-gutters>
              <v-col cols="12" class="my-1"> {{ $t('message.name') }} </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editingThumbnail.title"
                  dense
                  outlined
                  hide-details
                  :placeholder="'Nome da Thumb'"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-4 mb-1">
                <v-row no-gutters>
                  <v-col cols="6" class="pr-2">
                    {{ $t('message.pages.videoPlayerButtons.start') }} ({{
                      timePickerFormat
                    }})
                  </v-col>
                  <v-col cols="6" class="pl-2">
                    {{ $t('message.pages.pauseThumbnail.end') }} ({{
                      timePickerFormat
                    }})
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col cols="6" class="pr-2">
                    <!-- start -->
                    <AntTimePicker
                      :startVal="editingThumbnail.startTime"
                      :timeVideo="timeVideo"
                      :currentVal="editingThumbnail.startTime"
                      :disabled="editingThumbnail.lastAllVideo"
                      @changedTime="handleStartTimeEvent"
                    />
                  </v-col>
                  <v-col cols="6" class="pl-2">
                    <!-- end -->
                    <AntTimePicker
                      :key="
                        isLowerOrEqual
                          ? editingThumbnail.startTime
                          : editingThumbnail.endTime
                      "
                      :startVal="
                        isLowerOrEqual
                          ? editingThumbnail.startTime
                          : editingThumbnail.endTime
                      "
                      :thresholdTime="editingThumbnail.startTime"
                      :timeVideo="timeVideo"
                      :currentVal="editingThumbnail.endTime"
                      :disabled="
                        editingThumbnail.lastAllVideo ||
                        editingThumbnail.lastTillEnd
                      "
                      @changedTime="handleEndTimeEvent"
                    />
                  </v-col>
                  <v-col cols="12" class="mt-2">
                    <v-row no-gutters>
                      <v-col cols="6" class="pr-2">
                        <v-checkbox
                          v-model="editingThumbnail.lastAllVideo"
                          :label="
                            $t('message.pages.videoPlayerButtons.lastAllVideo')
                          "
                          class="pa-0 ma-0"
                          color="primary"
                          hide-details
                          @click="handleLastAllVideo"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="6" class="pl-2">
                        <v-checkbox
                          v-model="editingThumbnail.lastTillEnd"
                          :label="
                            $t('message.pages.videoPlayerButtons.lastTillEnd')
                          "
                          dense
                          class="pa-0 ma-0"
                          color="primary"
                          hide-details
                          @click="handleLastTillEnd"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col v-if="checkIfIsBetweenInterval" cols="12">
                    <span class="red--text caption align-text">
                      <v-icon color="red" size="16" class="pb-1 pt-1 pr-1">
                        mdi-alert-circle
                      </v-icon>
                      {{
                        $t(
                          'message.pages.pauseThumbnail.alreadyExistsInThisTime'
                        )
                      }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="d-md-inline-flex mt-6">
                <v-card
                  class="d-flex flex-column justify-center align-center mr-3 card-thumbnail"
                  height="83px"
                  width="150px"
                >
                  <v-file-input
                    v-model="newPauseThumbnail.file"
                    height="20px"
                    class="d-flex align-center justify-center ma-0 pa-0 pl-2"
                    hide-input
                    prepend-icon="mdi-cloud-upload-outline"
                    accept="image/png, image/jpeg, image/gif"
                    @change="showPreviewImg"
                  ></v-file-input>
                  <span
                    style="
                      font-size: 12px;
                      text-align: center;
                      position: absolute;
                      top: 43px;
                    "
                  >
                    {{ $t('message.pages.video.thumbUpload') }}
                  </span>
                </v-card>

                <v-hover v-slot="{ hover }">
                  <v-card
                    class="mr-4 d-flex align-center justify-center card-current-thumb"
                    height="83px"
                    width="150px"
                    :class="{
                      'on-hover': hover && !isBunnyThumbnail,
                    }"
                  >
                    <template v-if="!defaultPauseThumbnail && !previewImg">
                      <v-img
                        max-width="50"
                        max-height="50"
                        src="@/assets/pandaHappy.svg"
                      ></v-img>
                    </template>
                    <template v-else-if="defaultPauseThumbnail || previewImg">
                      <img
                        style="max-height: 100%"
                        :src="previewImg || defaultPauseThumbnail"
                      />
                    </template>
                  </v-card>
                </v-hover>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-row no-gutters align="center">
                  <span class="pt-4 mr-3"
                    >{{ $t('message.pages.videoPlayerButtons.addBtn') }}?</span
                  >
                  <v-switch
                    v-model="editingThumbnail.hasButton"
                    inset
                    dense
                    hide-details
                  ></v-switch>
                </v-row>
              </v-col>
            </v-row>
            <video-player-buttons
              v-if="editingThumbnail.hasButton"
              :isThumbButton="true"
              :handleBack="handleBack"
            />
            <v-col
              cols="12"
              class="d-flex flex-row align-end mt-8"
              v-if="hasEditVideoPerm"
            >
              <v-spacer />
              <v-btn min-width="150" plain @click="handleBackFromThumbForm">{{
                $t('message.pages.videoPlayerButtons.cancel')
              }}</v-btn>
              <v-btn
                min-width="150"
                color="primary"
                :disabled="loadingPauseThumbnail || checkIfCanUpload"
                :loading="loadingPauseThumbnail"
                @click="handlePublishPauseThumbnail"
                >{{ $t('message.pages.videoPlayerButtons.publish') }}</v-btn
              >
            </v-col>
          </v-col>
        </v-row>

        <v-row class="pb-3 pt-1 px-2" v-if="editingThumbnail.type == 'end'">
          <v-col cols="12" class="pb-0">
            <span class="mt-4" style="font-weight: 500; font-size: 18px">
              {{ $t('message.pages.video.endThumbnail') }}
            </span>
          </v-col>
          <v-col cols="12" class="pt-1">
            <v-card flat>
              <span>
                {{ $t('message.pages.video.endThumbnailText') }}
              </span>
            </v-card>
          </v-col>

          <v-col cols="12" class="d-md-inline-flex">
            <v-card
              v-if="hasEditVideoPerm"
              class="d-flex flex-column justify-center align-center mr-3 card-thumbnail"
              height="83px"
              width="150px"
            >
              <v-file-input
                v-if="!loadingEndThumbnail"
                v-model="newEndThumbnail.file"
                height="20px"
                class="d-flex align-center justify-center ma-0 pa-0 pl-2"
                hide-input
                prepend-icon="mdi-cloud-upload-outline"
                accept="image/png, image/jpeg, image/gif"
                @change="handleUploadEndThumbnail"
              />
              <span
                v-if="!loadingEndThumbnail"
                style="
                  font-size: 12px;
                  text-align: center;
                  position: absolute;
                  top: 43px;
                "
              >
                {{ $t('message.pages.video.thumbUpload') }}
              </span>
              <v-progress-circular
                v-else
                :size="22"
                width="3"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-card>

            <v-hover v-slot="{ hover }">
              <v-card
                class="mr-4 d-flex align-center justify-center card-current-thumb"
                height="83px"
                width="150px"
                :class="{
                  'on-hover': hover && !isBunnyThumbnail,
                }"
              >
                <template v-if="!defaultEndThumbnail">
                  <v-img
                    max-width="50"
                    max-height="50"
                    src="@/assets/pandaHappy.svg"
                  ></v-img>
                </template>
                <template
                  v-else-if="defaultEndThumbnail && !loadingDeleteEndThumb"
                >
                  <img style="max-height: 100%" :src="defaultEndThumbnail" />
                </template>

                <div
                  class="align-self-center"
                  v-if="defaultEndThumbnail && !loadingDeleteEndThumb"
                >
                  <v-btn
                    filter
                    icon
                    class="btn-handle-delete"
                    :class="{ 'show-btn-handle-delete': hover }"
                    @click="handleDeleteEndThumbnail('removeButton')"
                  >
                    <v-icon> mdi-close </v-icon>
                  </v-btn>
                </div>
                <v-progress-circular
                  v-if="loadingDeleteEndThumb"
                  :size="22"
                  width="3"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>

        <v-card flat class="pt-2">
          <v-row
            no-gutters
            v-if="successfulChangedThumb && !errors.updateThumbnailVideo"
          >
            <v-col class="pa-0" style="max-width: min-content">
              <v-icon color="primary">mdi-check</v-icon>
            </v-col>
            <v-col class="pa-0">
              <span
                class="caption align-text"
                v-html="$t('message.pages.videoEditModal.serverUpdateOnUpload')"
              />
            </v-col>
          </v-row>

          <v-row
            no-gutters
            v-else-if="successfulDeleteThumb && !errors.updateThumbnailVideo"
          >
            <v-col class="pa-0" style="max-width: min-content">
              <v-icon color="primary">mdi-check</v-icon>
            </v-col>
            <v-col class="pa-0">
              <span
                class="caption align-text"
                v-html="$t('message.pages.video.serverDeleteThumbnail')"
              />
            </v-col>
          </v-row>

          <v-row
            no-gutters
            v-else-if="
              errors.updateThumbnailVideo &&
              (editingThumbnail.type === 'start' ||
                editingThumbnail.type === 'end')
            "
          >
            <v-col class="px-2">
              <span
                class="caption align-text"
                style="color: #f44336"
                v-html="$t('message.pages.video.errors.updateThumbnail')"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
/* eslint-disable */

// external imports
import { mapActions, mapMutations, mapState } from 'vuex'
import _ from 'lodash'

// internal imports
import { THUMB_URL } from '@/config/envs.js'
import linkHelper from '@/utils/linkHelper.mixin.js'

// API
import videosApi from '@/services/videosApi'
import playerApi from '../../../services/playerApi'

// Components
import VideoPlayerButtons from './VideoPlayerButtons.vue'
import LearnMoreBtn from '@/components/LearnMoreBtn.vue'
import AntTimePicker from '@/components/AntTimePicker.vue'

export default {
  name: 'VideoPlayerThumbnails',
  components: {
    VideoPlayerButtons,
    LearnMoreBtn,
    AntTimePicker,
  },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    liveVideoId: {
      required: false,
    },
  },
  mixins: [linkHelper],
  data: () => ({
    videoId: '',
    newThumbnail: {
      file: null,
    },
    newPauseThumbnail: {
      file: null,
    },
    newEndThumbnail: {
      file: null,
    },
    loading: false,
    loadingPauseThumbnail: false,
    loadingEndThumbnail: false,
    loadingDeleteThumb: false,
    loadingDeletePauseThumb: false,
    loadingDeleteEndThumb: false,
    successfulChangedThumb: false,
    successfulChangedPauseThumb: false,
    successfulChangedEndThumb: false,
    successfulDeleteThumb: false,
    successfulDeletePauseThumb: false,
    successfulDeleteEndThumb: false,
    errors: {
      addThumbnail: false,
      wrongThumbnailFile: false,
      updateThumbnailVideo: false,
      updateThumbnailPauseVideo: false,
      updateThumbnailEndVideo: false,
    },
    defaultThumbnail: null,
    defaultPauseThumbnail: null,
    defaultEndThumbnail: null,
    arrayCtas: [],
    havePauseThumb: false,
    haveEndThumb: false,
    activeSkipButton: true,
    loadingSkipButton: false,
    isEditingThumb: false,
    editingThumbnail: {
      title: '',
      startTime: '00:00',
      endTime: '00:05',
      hasButton: false,
      type: 'start',
      lastTillEnd: false,
      lastAllVideo: false,
    },
    timeVideo: null,
    scrollInvoked: 0,
    pauseThumbnails: [],
    beingEditedPauseThumb: {},
    isThumbUpdate: false,
    beingDeletePauseThumbId: '',
    previewImg: null,
    videoHours: 0,
    videoMinutes: 0,
    videoSeconds: 0,
    popupStartTime: true,
    popupEndTime: true,
  }),
  async mounted() {
    this.formatVideoLength()

    this.videoId = this.liveVideoId ?? this.$route.params.id
    this.arrayCtas = this.$store.state.video.video.config?.ctas ?? []
    this.defaultThumbnail = this.$store.state.video.video?.thumbnail
    this.defaultEndThumbnail = this.$store.state.video.video?.endThumbnail

    let pauseThumbs = this.arrayCtas.filter((item) => item.type === 'pause')
    let mappedPauseThumbs = pauseThumbs.map((item) => {
      if (item.metadata) return item
      else {
        let thumbName = this.$store.state.video.video?.config.pauseThumbnail

        return {
          ...item,
          metadata: {
            thumb: { ...this.editingThumbnail, title: 'Thumb', type: 'pause' },
            button: {},
            fileUrl: this.$store.state.video.video?.pauseThumbnail,
            thumbId: thumbName,
          },
          startTime: 0,
          endTime: this.$store.state.video.video?.length,
        }
      }
    })

    this.pauseThumbnails = mappedPauseThumbs

    if (!this.pauseThumbnails) {
      this.editingThumbnail.endTime = this.$store.state.video.video?.length
    }

    this.$root.$on('buttonsFormInfo', (formInfo) => {
      this.handleUploadPauseThumbnail(formInfo)
    })
  },
  beforeDestroy() {
    this.$root.$off('buttonsFormInfo')
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      profile_id: (state) => state.video.profile_id,
      internalError: (state) => state.video.internalError,
    }),
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
    timePickerFormat() {
      if (this.timeVideo >= 3600) {
        return 'HH:mm:ss'
      }
      return 'mm:ss'
    },
    isBunnyThumbnail() {
      return this.defaultThumbnail
        ? this.defaultThumbnail.includes('thumbnail.jpg')
        : false
    },
    checkIfCanUpload() {
      return (
        (!this.isThumbUpdate && !this.newPauseThumbnail.file) ||
        this.checkIfIsBetweenInterval
      )
    },
    checkIfIsBetweenInterval() {
      let hasNewThumbCreated = false
      let x = this.pauseThumbnails.map((el) => {
        if (el.id === this.beingEditedPauseThumb.id)
          return { start: -1, end: -1 }
        if (!hasNewThumbCreated && (el.startTime || el.endTime)) {
          hasNewThumbCreated = true
        }
        return {
          start: el.startTime,
          end: el.endTime,
        }
      })
      let result = []
      let z = {
        start: this.formatTimeToSeconds(this.editingThumbnail.startTime),
        end: this.formatTimeToSeconds(this.editingThumbnail.endTime),
      }
      if (hasNewThumbCreated) {
        result = x.filter(
          (i) =>
            this.inRange(z.start, i.start, i.end) ||
            this.inRange(z.end, i.start, i.end)
        )
      } else {
        result = x.filter(
          (i) =>
            this.inRange(z.start, i.start, i.end) ||
            this.inRange(z.end, i.start, i.end)
        )
      }
      return !!result.length
    },
    isLowerOrEqual() {
      const { endTime, startTime } = this.editingThumbnail
      return endTime < startTime
    },
  },
  watch: {
    successfulChangedThumb() {
      if (this.successfulChangedThumb) {
        setTimeout(() => {
          this.successfulChangedThumb = false
        }, 20000)
      }
    },
  },
  methods: {
    ...mapActions('video', [
      'updateCta',
      'getVideoConfig',
      'createProfile',
      'setProfileToVideos',
      ,
    ]),
    ...mapMutations('video', ['UPDATE_VIDEO', 'UPDATE_STATUS_ERROR']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleOpenThumbLink() {
      window.open(this.getPauseThumbnailLink(), '_blank')
    },
    inRange(x, min, max) {
      return (x - min) * (x - max) <= 0
    },
    showPreviewImg() {
      this.previewImg = URL.createObjectURL(this.newPauseThumbnail.file)
    },
    handlePublishPauseThumbnail() {
      if (this.editingThumbnail.hasButton) {
        this.$root.$emit('getPauseThumbButton')
      } else {
        this.handleUploadPauseThumbnail()
      }
    },
    onScroll() {
      this.scrollInvoked++
    },
    handleBackFromThumbForm() {
      this.previewImg = null
      this.isEditingThumb = false
    },
    resetForm() {
      this.defaultPauseThumbnail = ''
      this.editingThumbnail = {
        title: '',
        startTime: '00:00',
        endTime: '00:05',
        hasButton: false,
        type: 'pause',
      }
      this.previewImg = null
      this.isThumbUpdate = false
      this.newPauseThumbnail.file = null
    },
    handleEditThumb(thumbnailCta) {
      this.resetForm()
      this.isThumbUpdate = false
      if (thumbnailCta?.id) {
        if (thumbnailCta.metadata.thumb) {
          this.editingThumbnail = thumbnailCta.metadata.thumb
          this.editingThumbnail.startTime = this.formatSecondsToTime(
            thumbnailCta.startTime
          )
          this.editingThumbnail.endTime = this.formatSecondsToTime(
            thumbnailCta.endTime
          )
        }
        this.defaultPauseThumbnail = thumbnailCta.metadata.fileUrl
        this.beingEditedPauseThumb = thumbnailCta
        this.isThumbUpdate = true
      }
      this.isEditingThumb = true
      if (thumbnailCta?.metadata?.button) {
        setTimeout(() => {
          this.$root.$emit('editPauseThumbButton', thumbnailCta.metadata.button)
        }, 300)
      }
    },
    handleChangeThumbType(type) {
      this.isEditingThumb = this.arrayCtas.length === 0
      this.editingThumbnail.type = type
    },
    async handleChangeThumbnail() {
      this.successfulDeleteThumb = false
      this.successfulChangedThumb = false
      this.clearErrors()
      const file = this.newThumbnail.file
      let fileExtension =
        file?.name?.substring(
          file?.name?.lastIndexOf('.') + 1,
          file?.name?.length
        ) || file?.name
      if (
        fileExtension !== 'jpg' &&
        fileExtension !== 'png' &&
        fileExtension !== 'jpeg' &&
        fileExtension !== 'gif'
      ) {
        this.errors.wrongThumbnailFile = true
        this.newThumbnail.file = null
        return
      }
      this.loading = true
      const data = new FormData()
      data.append('file', file)
      try {
        const ret = await videosApi.addThumbnailToVideo(this.videoId, data)
        await this.getVideoConfig(this.videoId)
        this.loading = false
        this.defaultThumbnail = `${process.env.VUE_APP_THUMB_API}/${this.video.pullzone_name}/${ret.data.response.thumb}`
        this.successfulChangedThumb = true
        return ret
      } catch (e) {
        this.loading = false
        this.errors.updateThumbnailVideo = true
      }
      this.loading = false
    },
    async handleUploadPauseThumbnail(formInfo) {
      this.successfulDeleteThumb = false
      this.successfulChangedThumb = false
      this.clearErrors()
      const file = this.newPauseThumbnail.file
      let data
      if (file) {
        let fileExtension =
          file?.name?.substring(
            file?.name?.lastIndexOf('.') + 1,
            file?.name?.length
          ) || file?.name
        if (
          fileExtension !== 'jpg' &&
          fileExtension !== 'png' &&
          fileExtension !== 'jpeg' &&
          fileExtension !== 'gif'
        ) {
          this.errors.wrongThumbnailFile = true
          this.newPauseThumbnail.file = null
          return
        }
        data = new FormData()
        data.append('file', file)
      }
      this.loadingPauseThumbnail = true
      try {
        if (this.isThumbUpdate) {
          await this.handleDeletePauseThumbnail(
            this.beingEditedPauseThumb.id,
            this.beingEditedPauseThumb.metadata.thumbId,
            !!data
          )
        }
        let ret
        if (data) {
          ret = await videosApi.addThumbnailToPauseVideo(this.videoId, data)
        }
        let thumbName =
          ret?.data?.response?.pauseThumbnail[0] ||
          this.beingEditedPauseThumb.metadata.thumbId
        await this.handleUpdateConfigPauseThumbnail({
          ...formInfo,
          thumbName: thumbName,
        })
      } catch (e) {
        this.loadingPauseThumbnail = false
      }
      this.loadingPauseThumbnail = false
    },
    async handleUpdateSkipButton() {
      try {
        if (this.thumbnailHas('pause')) {
          const oldThumbCta = this.arrayCtas.filter((el) => el.type === 'pause')
          await playerApi.deleteCta(this.videoId, oldThumbCta[0].id)
          const currentPauseThumbnail =
            this.$store.state.video.video?.pauseThumbnail
          const cta = await this.generateThumbCta(
            currentPauseThumbnail,
            'pauseThumbnail'
          )
          const ret = await playerApi.addCta(this.videoId, cta)

          this.arrayCtas = ret.data.ctas
          await this.getVideoConfig(this.videoId)
        }
      } catch (error) {}
      this.loadingSkipButton = false
    },
    async handleUploadEndThumbnail() {
      this.successfulDeleteThumb = false
      this.successfulChangedThumb = false

      this.clearErrors()

      const { file } = this.newEndThumbnail

      let fileExtension =
        file?.name?.substring(
          file?.name?.lastIndexOf('.') + 1,
          file?.name?.length
        ) || file?.name

      if (!['jpg', 'png', 'jpeg', 'gif'].includes(fileExtension)) {
        this.errors.wrongThumbnailFile = true
        this.newEndThumbnail.file = null

        return
      }

      this.loadingEndThumbnail = true

      const data = new FormData()
      data.append('file', file)

      try {
        if (this.thumbnailHas('end')) await this.handleDeleteEndThumbnail()

        let ret = await videosApi.addThumbnailToEndVideo(this.videoId, data)
        let thumbName = ret.data.response.endThumbnail

        await this.handleUpdateConfigEndThumbnail(thumbName)
      } catch (e) {
        this.loadingEndThumbnail = false
      }

      this.loadingEndThumbnail = false
    },
    getThumbsLink(thumb) {
      return `${THUMB_URL}/${this.$store.state.video.video?.pullzone_name}/${thumb}`
    },
    async handleUpdateConfigPauseThumbnail(formInfo) {
      const currentPauseThumbnail = this.getThumbsLink(formInfo.thumbName)
      try {
        const cta = await this.generateThumbCta(
          currentPauseThumbnail,
          'pauseThumbnail',
          formInfo
        )
        const ret = await playerApi.addCta(this.videoId, cta)
        let pauseArray = ret.data.ctas.filter((item) => item.type === 'pause')
        let lastItem = pauseArray[pauseArray.length - 1]
        pauseArray.pop()
        pauseArray.unshift(lastItem)
        this.pauseThumbnails = pauseArray
        this.handleBackFromThumbForm()
        await this.getVideoConfig(this.videoId)
        this.arrayCtas = ret.data.ctas
        this.internalError
          ? ''
          : ((this.withoutChanges = true),
            (this.loadingPauseThumbnail = false),
            (this.defaultPauseThumbnail =
              this.$store.state.video.video?.pauseThumbnail),
            (this.successfulChangedThumb = true),
            this.changePlayer(),
            (this.loadingSkipButton = false),
            this.handleSnackbar())
      } catch (e) {
        console.error(e)
        this.loadingButtonSave = false
      }
    },
    async handleUpdateConfigEndThumbnail(thumbName) {
      const endThumbnailLink = this.getThumbsLink(thumbName)

      try {
        const cta = await this.generateThumbCta(
          endThumbnailLink,
          'endThumbnail',
          null
        )
        const ret = await playerApi.addCta(this.videoId, cta)

        this.arrayCtas = ret.data.ctas

        if (this.internalError) {
          this.withoutChanges = true
          this.loadingEndThumbnail = false
          this.successfulChangedThumb = true

          this.changePlayer()

          this.loadingSkipButton = false

          this.handleSnackbar()
        }

        this.defaultEndThumbnail = endThumbnailLink
      } catch (e) {
        console.error(e)
        this.loadingButtonSave = false
      }
    },
    async generateThumbCta(thumbnail, type, formInfo) {
      let codeThumbnail
      let ctaScript
      if (type === 'pauseThumbnail') {
        if (this.editingThumbnail.hasButton) {
          ctaScript = formInfo.script.replace(
            'PAUSE_THUMBNAIL_REPLACE',
            thumbnail
          )
        } else {
          ctaScript =
            `<img src='${thumbnail}' style='object-fit:cover; width:100%; height:100%;'><script>document.querySelector('img').onclick=function() { window.parent.postMessage({type: 'cta_play',}, '*') }</scr` +
            `ipt>`
        }
      }
      if (type === 'pauseThumbnail') {
        codeThumbnail = thumbnail
          ? {
              id: this.generateUuid(),
              script: ctaScript,
              type: 'pause',
              metadata: {
                thumb: this.editingThumbnail,
                button: formInfo.buttonMetadata,
                fileUrl: thumbnail,
                thumbId: formInfo.thumbName,
              },
              startTime: this.formatTimeToSeconds(
                this.editingThumbnail.startTime
              ),
              endTime: this.formatTimeToSeconds(this.editingThumbnail.endTime),
            }
          : false
      }
      if (type === 'endThumbnail') {
        codeThumbnail = {
          id: this.generateUuid(),
          script:
            `<img src='${thumbnail}' style='object-fit:cover; width:100%; height:100%;'><script>document.querySelector('img').onclick=function() { window.parent.postMessage({type: 'cta_play',}, '*') }</scr` +
            `ipt>`,
          type: 'end',
        }
      }
      return codeThumbnail
    },
    changePlayer() {
      const arrayCtas = this.$store.state.video.video.config?.ctas
      if (!arrayCtas) {
        return
      }
      if (this.video.hasOwnProperty('video_source')) {
        this.$root.$emit('setCtas', arrayCtas)
      } else {
        const iframe = document.getElementById('panda-player').contentWindow
        iframe.postMessage(
          {
            type: 'ctas',
            parameter: {
              ctas: arrayCtas,
            },
          },
          '*'
        )
        return
      }
    },
    async handleDeleteThumbnail() {
      this.successfulDeleteThumb = false
      this.successfulChangedThumb = false
      this.clearErrors()
      this.loadingDeleteThumb = true
      try {
        const ret = await videosApi.deleteThumbnailVideo(this.videoId)
        await this.getVideoConfig(this.videoId)
        this.loadingDeleteThumb = false
        this.defaultThumbnail = this.$store.state.video.video.thumbnail
        this.successfulDeleteThumb = true

        return ret
      } catch (error) {
        this.loadingDeleteThumb = false
        this.errors.updateThumbnailVideo = true
      }
    },
    async handleRemoveThumb(pauseCta) {
      await this.handleDeletePauseThumbnail(
        pauseCta.id,
        pauseCta.metadata.thumbId,
        true
      )

      this.isEditingThumb = this.arrayCtas.length === 0
    },
    async handleDeletePauseThumbnail(ctaId, thumbName, shouldRemoveThumbFile) {
      this.successfulDeletePauseThumb = false
      this.successfulChangedPauseThumb = false
      this.clearErrors()
      this.loadingDeletePauseThumb = true
      try {
        let ret
        if (shouldRemoveThumbFile) {
          this.beingDeletePauseThumbId = ctaId
          ret = videosApi.deleteThumbnailPauseVideo(this.videoId, thumbName)
        }
        const res = await playerApi.deleteCta(this.videoId, ctaId)
        await this.getVideoConfig(this.videoId)
        this.arrayCtas = res.data.ctas
        this.pauseThumbnails = this.pauseThumbnails.filter(
          (item) => item.id !== ctaId
        )
        this.changePlayer()
        this.loadingDeletePauseThumb = false
        this.defaultPauseThumbnail = null
        this.havePauseThumb = false
        if (removeButton === 'removeButton') {
          this.successfulDeleteThumb = true
        }
        this.beingDeletePauseThumbId = ''
        return ret
      } catch (error) {
        this.loadingDeletePauseThumb = false
        this.havePauseThumb = true
      }
    },
    async handleDeleteEndThumbnail(removeButton = null) {
      this.successfulDeleteEndThumb = false
      this.successfulChangedEndThumb = false

      this.clearErrors()

      this.loadingDeleteEndThumb = true

      try {
        const found = _.filter(this.arrayCtas, { type: 'end' })
        let res

        for (let i = 0; i < found.length; i++) {
          try {
            await videosApi.deleteThumbnailEndVideo(this.videoId)
          } catch {}
        }

        for (const { id } of found) {
          res = await playerApi.deleteCta(this.videoId, id)
        }

        await this.getVideoConfig(this.videoId)

        this.arrayCtas = res.data.ctas

        this.UPDATE_STATUS_ERROR(false)

        this.changePlayer()
        this.loadingDeleteEndThumb = false
        this.defaultEndThumbnail = null
        this.haveEndThumb = false

        if (removeButton === 'removeButton') this.successfulDeleteThumb = true
      } catch (error) {
        this.loadingDeleteEndThumb = false
        this.haveEndThumb = true
      }
    },
    thumbnailHas(value) {
      const arrayCtas = this.$store.state.video.video.config?.ctas

      if (!arrayCtas) return false

      return arrayCtas.some((item) => item.type === value)
    },
    generateUuid() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      )
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
    },
    handleSnackbar(item) {
      if (!item) {
        item = this.$i18next.t('message.pages.video.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
    formatSecondsToTime(seconds) {
      let res = new Date(seconds * 1000).toISOString()
      if (this.timeVideo < 3600) {
        return res.substring(14, 19)
      }
      return res.substring(11, 19)
    },
    formatTimeToSeconds(time) {
      let res = time.split(':').reduce((acc, time) => 60 * acc + +time)
      return res
    },
    formatVideoLength() {
      let videoLength = this.$store.state.video.video?.length
      this.timeVideo = videoLength
      this.videoHours = Math.floor(videoLength / 3600)
      this.videoMinutes = Math.floor((videoLength % 3600) / 60)
      this.videoSeconds = videoLength % 60
    },
    handleStartTimeEvent(val) {
      this.editingThumbnail.lastAllVideo = false
      this.editingThumbnail.startTime = val
    },
    handleEndTimeEvent(val) {
      this.editingThumbnail.lastTillEnd = false
      this.editingThumbnail.endTime = val
    },
    handleLastAllVideo() {
      if (this.editingThumbnail.lastAllVideo) {
        this.editingThumbnail.startTime = this.getDefaultTimes().start
        this.editingThumbnail.endTime = this.formatSecondsToTime(this.timeVideo)
        this.editingThumbnail.lastTillEnd = false
      }
    },
    handleLastTillEnd() {
      if (this.editingThumbnail.lastTillEnd) {
        this.editingThumbnail.endTime = this.formatSecondsToTime(this.timeVideo)
        this.editingThumbnail.lastAllVideo = false
      }
    },
    getDefaultTimes() {
      if (this.timeVideo && this.timeVideo >= 3600) {
        return {
          start: '00:00:00',
          end: '00:05:00',
        }
      }
      return {
        start: '00:00',
        end: '00:05',
      }
    },
  },
}
</script>

<style>
.card-thumbnail {
  border-style: dashed;
  border-color: rgba(0, 0, 0, 0.87) !important;
}

.card-thumbnail .v-icon.v-icon::after {
  background-color: transparent !important;
}

.card-thumbnail .v-icon {
  width: 150px !important;
  height: 83px !important;
  z-index: 2;
}

.card-thumbnail .v-icon:before {
  margin-top: -25px !important;
}

.card-thumbnail .v-input__icon {
  width: 150px !important;
}

.card-thumbnail .v-input {
  padding: 0 !important;
}

.card-thumbnail .v-input__prepend-outer {
  margin-right: 0 !important;
}

.default-thumbnail {
  display: flex;
  cursor: default;
  opacity: 0;
  position: absolute;
  padding: 0.2rem 0.5rem;
  width: 100%;
  height: 100%;
  text-align: center;
  align-items: center;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  transition: ease-in-out 0.3s all;
}

.default-thumbnail:hover {
  opacity: 1;
}

.btn-handle-delete {
  opacity: 0;
  position: absolute;
  bottom: 67px;
  left: 134px;
  background: #282525;
  height: 30px !important;
  width: 30px !important;
}

.btn-handle-delete span i {
  color: #fff !important;
  height: 17px !important;
  font-size: 17px !important;
  width: 19px !important;
}

.show-btn-handle-delete {
  opacity: 1 !important;
}

.thumb-preview {
  height: 83px;
  width: 150px;
  background-size: cover !important;
  background-position: 50% 50% !important;
  background-repeat: no-repeat !important;
}
</style>
